import React from "react";
import Navbar from "../navigation/Navbar";
import { Item, Aside } from "../navigation/Aside";
import { Messages } from "../../helpers/message-helper";

/**
 * Componente Toolbar que corresponde a la barra de herramientas del visor.
 */
export default class Toolbar extends React.Component {
  /**
   * Se encarga de disparar el evento
   * @param {*} name
   */
  on(name) {
    this.props.on(name);
  }

  /**
   * Renderiza el componente
   */
  render() {
    return (
      <Aside>
        <Item id="buscadorControl" icon="search" onClick={evt => this.on("buscar")}>
          {Messages.get("Visor.searchControl.tooltip")}
        </Item>
        <Item id="lonlatControl" icon="search-location" onClick={evt => this.on("lonlat")}>
          {Messages.get("Visor.lonlatControl.tooltip")}
        </Item>
        <Item id="infoControl" icon="hand-point-up" onClick={evt => this.on("informacion")}>
          {Messages.get("Visor.infoControl.tooltip")}
        </Item>

        <Item id="coordControl" icon="map-marker-alt" onClick={evt => this.on("ubicacion")}>
          {Messages.get("Visor.coordControl.tooltip")}
        </Item>

        <Item id="geoloControl" icon="street-view" onClick={evt => this.on("geolocalizacion")}>
          {Messages.get("Visor.geoloControl.tooltip")}
        </Item>

        <Item icon="question-circle" onClick={evt => this.on("ayuda")}>
          {Messages.get("Visor.helpControl.tooltip")}
        </Item>
      </Aside>
    );
  }
}
